module.exports = __webpack_public_path__ + "static/img/iso4.06deaca6.png";